import { AvatarUrls, Issue, ReportedBug, TestStep } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';
import { StatusUtils } from '@qality/common-utils';

type FormatedFailedStep = {
  testExecution: {
    createdDate: number;
    id: number;
    testCycle: {
      name: string;
      id: number;
    };
  };
  testStep: {
    name: string;
    comment: string;
    linkedIssues: Array<Issue>;
  };
};

type FormatedReportedBug = {
  testExecution: {
    createdDate: number;
    id: number;
  };
  linkedIssue: {
    created: string;
    reporter?: {
      userName: string;
      userAvatar: AvatarUrls;
    };
    status: {
      kind: string;
      text: string;
    };
    iconSrc: string;
    title: string;
    issueKey: string;
    issueLink: string;
  };
};

export default {
  formatReportedBug: (
    reportedBug: ReportedBug,
    issue: Issue
  ): FormatedReportedBug => {
    const { reporter: reporterField } = issue.fields;
    return {
      testExecution: {
        createdDate: reportedBug.testExecution.createdDate,
        id: reportedBug.testExecution.id,
      },
      linkedIssue: {
        created: issue.fields.created,
        reporter: reporterField
          ? {
              userName: reporterField.displayName,
              userAvatar: reporterField.avatarUrls['16x16'],
            }
          : null,
        status: {
          kind: StatusUtils.getAppearanceType(
            issue.fields.status.statusCategory.colorName
          ),
          text: issue.fields.status.name,
        },
        iconSrc: issue.fields.issuetype.iconUrl,
        title: issue.fields.summary,
        issueKey: issue.key,
        issueLink: StorageOfUniqueServices.get('URLService').getIssueURL(
          issue.key
        ),
      },
    };
  },
  formatFailedStep: (failedStep: TestStep): FormatedFailedStep => {
    return {
      testExecution: {
        createdDate: failedStep.testExecution.createdDate,
        id: failedStep.testExecution.id,
        testCycle: {
          name: failedStep.testExecution.testCaseInCycle?.testCycle.name,
          id: failedStep.testExecution.testCaseInCycle?.testCycle.id,
        },
      },
      testStep: {
        name: failedStep.testStepName,
        comment: failedStep.testStep.comment,
        linkedIssues: failedStep.testStep.linkedIssues,
      },
    };
  },
  async openTestExecutionInNewTab(id: number): Promise<void> {
    const url = await StorageOfUniqueServices.get(
      'URLService'
    ).getEmptyTestCaseExecutionUrl();
    window.open(url + id, '_BLANK');
  },
};
